type HarnessBaseAttributes = {
  env: string;
  platform: string;
  isLoggedIn: boolean;
};

export type HarnessStartupAttributes = HarnessBaseAttributes & HarnessUserData;

export type HarnessUserData = {
  externalId: string;
  countryOfResidence?: string;
};

export enum HarnessPlatform {
  WEB = 'web',
  DESKTOP = 'desktop',
  WEB_DESKTOP = 'web-desktop'
}

export enum HarnessFeatureFlags {
  ENABLE_SECURITY_PROFILES = 'ENABLE_SECURITY_PROFILES',
  DESKTOP_MAIN_SMOKE = 'DESKTOP_MAIN_SMOKE'
}

export const ANONYMOUS_FEATURE_FLAGS_FALLBACK_KEY = 'ANONYMOUS';
